/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Onboarding_Parq_Some_YesInputs */

const en_us2_onboarding_parq_some_yes = /** @type {(inputs: Onboarding_Parq_Some_YesInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Yes to 1 of the seven health questions`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`Yes to 1 of the seven health questions`);
	return /** @type {LocalizedString} */ (`Yes to ${i?.count} of the seven health questions`)
	
};

const pt_br2_onboarding_parq_some_yes = /** @type {(inputs: Onboarding_Parq_Some_YesInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Sim para 1 das sete perguntas de saúde`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`Sim para 1 das sete perguntas de saúde`);
	return /** @type {LocalizedString} */ (`Sim para ${i?.count} das sete perguntas de saúde`)
	
};

const es_419_onboarding_parq_some_yes = /** @type {(inputs: Onboarding_Parq_Some_YesInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Sí a 1 de las siete preguntas de salud`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`Sí a 1 de las siete preguntas de salud`);
	return /** @type {LocalizedString} */ (`Sí a ${i?.count} de las siete preguntas de salud`)
	
};

const pt_pt2_onboarding_parq_some_yes = /** @type {(inputs: Onboarding_Parq_Some_YesInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Sim a 1 das sete perguntas de saúde`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`Sim a 1 das sete perguntas de saúde`);
	return /** @type {LocalizedString} */ (`Sim a ${i?.count} das sete perguntas de saúde`)
	
};

const fr_fr2_onboarding_parq_some_yes = /** @type {(inputs: Onboarding_Parq_Some_YesInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Oui à 1 des sept questions de santé`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`Oui à 1 des sept questions de santé`);
	return /** @type {LocalizedString} */ (`Oui à ${i?.count} des sept questions de santé`)
	
};

const de_de2_onboarding_parq_some_yes = /** @type {(inputs: Onboarding_Parq_Some_YesInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Ja bei 1 der sieben Gesundheitsfragen`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`Ja bei 1 der sieben Gesundheitsfragen`);
	return /** @type {LocalizedString} */ (`Ja bei ${i?.count} der sieben Gesundheitsfragen`)
	
};

const it_it2_onboarding_parq_some_yes = /** @type {(inputs: Onboarding_Parq_Some_YesInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Sì a 1 delle sette domande sulla salute`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`Sì a 1 delle sette domande sulla salute`);
	return /** @type {LocalizedString} */ (`Sì a ${i?.count} delle sette domande sulla salute`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "Yes to 1 of the seven health questions" |
* | "-1" | "Yes to 1 of the seven health questions" |
* | * | "Yes to {count} of the seven health questions" |
*
* @param {Onboarding_Parq_Some_YesInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_parq_some_yes = /** @type {((inputs: Onboarding_Parq_Some_YesInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Parq_Some_YesInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_parq_some_yes(inputs)
	if (locale === "es-419") return es_419_onboarding_parq_some_yes(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_parq_some_yes(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_parq_some_yes(inputs)
	if (locale === "de-DE") return de_de2_onboarding_parq_some_yes(inputs)
	if (locale === "it-IT") return it_it2_onboarding_parq_some_yes(inputs)
	return en_us2_onboarding_parq_some_yes(inputs)
});
export { onboarding_parq_some_yes as "onboarding.parq.some_yes" }